<form [formGroup]="reasonCollectorForm" class="flex flex-col justify-center items-center">
  <mat-form-field mat-select-height-large class="reason-select">
    <mat-label>{{
      'DIAGNOSTICS.CONNECTION_REASON_FORM.REASON_DROPDOWN.LABEL' | translate
    }}</mat-label>
    <mat-select
      [formControlName]="RemoteDiagnosticsConnectionReasonsControls.ReasonType"
      gtm="onOpen"
      gtmAction="Open connection reason dropdown"
      gtmCategory="connectionReasonForm"
      fieldTextContentTooltip
      data-at-connection-reason-dropdown
    >
      <mat-option
        *ngFor="let reason of reasons"
        value="{{ 'DIAGNOSTICS.CONNECTION_REASON_FORM.REASON_DROPDOWN.' + reason | translate }}"
        (click)="onReasonChange(reason)"
        gtm="onSelect"
        gtmAction="Reason: '{{ reason }}'"
        gtmCategory="connectionReasonForm"
        fieldTextContentTooltip
        [attr.data-at-connection-reason-dropdown-option]="reason"
        >{{ 'DIAGNOSTICS.CONNECTION_REASON_FORM.REASON_DROPDOWN.' + reason | translate }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="reasonCollectorForm.controls.reasonType?.errors?.required">{{
      'FORM.ERROR.REQUIRED'
        | translate
          : {
              formField: 'DIAGNOSTICS.CONNECTION_REASON_FORM.REASON_DROPDOWN.LABEL' | translate
            }
    }}</mat-error>
  </mat-form-field>
  <ng-container [ngSwitch]="selectedReason">
    <ng-container *ngSwitchCase="RemoteDiagnosticsConnectionReasons.CUSTOMER_SUPPORT">
      <mat-form-field mat-input-height-large-label>
        <mat-label>{{
          'DIAGNOSTICS.CONNECTION_REASON_FORM.TICKET_NUMBER.PLACEHOLDER' | translate
        }}</mat-label>
        <input
          data-at-connection-reason-input-field
          gtm="onTextField"
          gtmAction="Ticket number"
          gtmCategory="connectionReasonForm"
          [gtmOn]="['change', 'focus', 'blur']"
          [formControlName]="RemoteDiagnosticsConnectionReasonsControls.TicketNumber"
          matInput
          required
          [minlength]="minlengthOfTicketNumber"
          [maxlength]="maxlengthOfTicketNumber"
          [pattern]="ticketNumberPattern"
          fieldTextContentTooltip
        />
        <mat-error *ngIf="reasonCollectorForm.controls.ticketNumber?.errors?.required">
          {{
            'FORM.ERROR.REQUIRED'
              | translate
                : {
                    formField:
                      'DIAGNOSTICS.CONNECTION_REASON_FORM.TICKET_NUMBER.PLACEHOLDER' | translate
                  }
          }}
        </mat-error>
        <mat-error *ngIf="reasonCollectorForm.controls.ticketNumber?.errors?.pattern">{{
          'FORM.ERROR.PATTERN'
            | translate
              : {
                  formField:
                    'DIAGNOSTICS.CONNECTION_REASON_FORM.TICKET_NUMBER.PLACEHOLDER' | translate
                }
        }}</mat-error>
        <mat-error *ngIf="reasonCollectorForm.controls.ticketNumber?.errors?.minlength">{{
          'FORM.ERROR.MIN'
            | translate
              : {
                  formField:
                    'DIAGNOSTICS.CONNECTION_REASON_FORM.TICKET_NUMBER.PLACEHOLDER' | translate
                }
        }}</mat-error>
        <mat-error *ngIf="reasonCollectorForm.controls.ticketNumber?.errors?.maxlength">{{
          'FORM.ERROR.MAX'
            | translate
              : {
                  formField:
                    'DIAGNOSTICS.CONNECTION_REASON_FORM.TICKET_NUMBER.PLACEHOLDER' | translate
                }
        }}</mat-error>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="RemoteDiagnosticsConnectionReasons.INSTALLER_SUPPORT">
      <mat-form-field mat-textarea class="textarea">
        <span mat-textarea-limit
          >{{ reasonCollectorForm.controls.descriptionText?.value.length }} /
          {{ maxlengthOfDescription }}</span
        >
        <textarea
          data-at-connection-reason-input-field
          gtm="onTextField"
          gtmAction="Description"
          gtmCategory="connectionReasonForm"
          [gtmOn]="['change', 'focus', 'blur']"
          [formControlName]="RemoteDiagnosticsConnectionReasonsControls.DescriptionText"
          matInput
          required
          [minlength]="minlengthOfDescription"
          [maxlength]="maxlengthOfDescription"
          placeholder="{{
            'DIAGNOSTICS.CONNECTION_REASON_FORM.DESCRIPTION.PLACEHOLDER' | translate
          }}"
        ></textarea>
        <mat-error *ngIf="reasonCollectorForm.controls.descriptionText?.errors?.required">{{
          'FORM.ERROR.REQUIRED'
            | translate
              : {
                  formField: 'DIAGNOSTICS.CONNECTION_REASON_FORM.DESCRIPTION.LABEL' | translate
                }
        }}</mat-error>
        <mat-error *ngIf="reasonCollectorForm.controls.descriptionText?.errors?.minlength">{{
          'FORM.ERROR.MIN'
            | translate
              : {
                  formField: 'DIAGNOSTICS.CONNECTION_REASON_FORM.DESCRIPTION.LABEL' | translate
                }
        }}</mat-error>
        <mat-error *ngIf="reasonCollectorForm.controls.descriptionText?.errors?.maxlength">{{
          'FORM.ERROR.MAX'
            | translate
              : {
                  formField: 'DIAGNOSTICS.CONNECTION_REASON_FORM.DESCRIPTION.LABEL' | translate
                }
        }}</mat-error>
      </mat-form-field>
    </ng-container>
  </ng-container>
</form>
